
<div class='json-viewer-frame'>
  <h3>JSON Data</h3>
  <json-editor [options]="editorOptions" [data]="_object" #editor></json-editor>
  <div *ngIf="!_readonly">
    <button pButton (click)="updateJson()">Update</button>
  </div>
</div>
